"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeForLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsDynamicCode_1 = require("../../model/hsDynamicCode");
var service_1 = require("../../../library/base/service");
var GetDynamicCodeForLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetDynamicCodeForLogin, _super);
    function GetDynamicCodeForLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '注册验证码获取接口';
        _this.code = '105030';
        _this.desc = '注册验证码获取接口';
        _this.requestParams = new hsDynamicCode_1.GetDynamicCodeForLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetDynamicCodeForLogin;
}(service_1.BaseService));
exports.GetDynamicCodeForLogin = GetDynamicCodeForLogin;
//# sourceMappingURL=getDynamicCodeForLogin.js.map